import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../../features/snackbar';
import { activateAlert } from '../../../../features/alert';

const DIALOG_ID = "activateAlert"
const DIALOG_WIDTH = "sm"

function ActivateAlertDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const project = useSelector(state => state.project.single);
    const alertId = useSelector((state) => state.dialog[DIALOG_ID])
    const alerts = useSelector(state => state.alert.list || state.alert.all);
    const alert = alerts && alerts.find(el => el.id === alertId);
    
    const alertLabel =  Array.isArray(alertId) ? "selected" : (alert ? alert.label : "");
    const show = !!alertId;

    const handleSubmit = e => {
        e && e.preventDefault() && e.stopPropagation();
        setLoading(true);
        dispatch(activateAlert(alertId))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Alert activated"))
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }
    // useEffect(() => {
    //     setLoading(false);
    // }, [show])

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={handleSubmit}>
            <DialogTitle>
                Activate alert
            </DialogTitle>
            <DialogContent dividers={false}>
                <Typography variant="subtitle1">Are you sure you want to activate the <b>{alertLabel}</b> alert?</Typography>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="success" type="submit">Activate</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default ActivateAlertDialog;